import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../Component/Sidebar/Sidebar";
import Header from "../Component/Header/Header";
import { useSidebar } from "../Context/SidebarContext";

function Layout() {
  const { open } = useSidebar();
  const location = useLocation();

  const fullScreenPages = ["/home-page"]; 
  const isFullScreen = fullScreenPages.includes(location.pathname);

  return (
    <div className="min-h-screen">
      <Sidebar />
      <div
        className={`transition-all duration-300 ease-in-out ${
          open
            ? "mr-[12rem] w-[calc(100%-12rem)]"
            : "mr-[3rem] w-[calc(100%-3rem)]"
        }`}
      >
        {!isFullScreen && <Header />}
        <div className={isFullScreen ? "" : "px-5"}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Layout;